import { pick, omitBy, isArray, trim } from "lodash";

// quoted value to initiate exact matching
export const toExactMatchQueryString = val => (val ? (isArray(val) ? val.map(v => `"${v}"`) : `"${val}"`) : undefined);
// remove quotes from value to ensure proper UI rendering
export const fromExactMatchQueryString = val => (val ? (isArray(val) ? val.map(v => trim(v, '"')) : trim(val, '"')) : undefined);

/**
 * Filter query object to keep only non-empty values.
 * Safely keeps booleans (true/false) and number 0, which lodash.isEmpty() would have omit.
 */
export const omitEmpty = query => omitBy(query, v => v === "" || v === null || v === undefined || (isArray(v) && v.length === 0));

/**
 * Serialize a query object into a URL search string.
 * Example: count_by=grant&pub_status=Active&pub_status=Unknown&alpha_threshold=60&pools=Mpeg-La+Hevc+Patents
 * This handles arrays by appending the key multiple times.
 */
export const serializeQuery = (query) => {
  if (!query) return "";
  const params = new URLSearchParams();
  Object.keys(query).forEach((key) => {
    const value = query[key];
    if (isArray(value)) {
      value.forEach((v) => {
        if (["string", "number", "boolean"].includes(typeof v)) {
          params.append(key, v);
        }
      });
    } else if (["string", "number", "boolean"].includes(typeof value)) {
      params.append(key, value);
    }
  });
  const search = params.toString();
  return search ? `?${search}` : "";
};

export const keepOnlyProsecutionQueryStrings = query => {
  return omitEmpty(pick(query, ["art_unit"]));
};

